export const NAME = 'mobileSidenav';
const mobileSidenavState = { showSideNav: false };
export const mobileSidenavReducer = (state = mobileSidenavState, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'SHOW_MOBILE_SIDENAV':
    case 'HIDE_MOBILE_SIDENAV':
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default {
  constants: { NAME },
  reducers: { mobileSidenavReducer },
};
